/**
 * @brief   Singleton de AppAjax.
 * @see     resources/js/scripts/functions/AppAjax.class.js
 */
require('./functions/AppAjax.class');
let AppAjax = window.AppAjax;

/*
|--------------------------------------------------------------------------
| DEBUT DU FICHIER - NE RIEN AJOUTER D'AUTRE QUE require() AU DESSUS !
|--------------------------------------------------------------------------
*/

/**
 * @brief   Fonctionnalités de la page des soumissions
 */
jQuery(document).ready(function() {
    // Exécution du code uniquement si l'élément du DOM existe
    if (jQuery('section[class^=section-utilisateurs]').html() !== undefined) {
        // Méthodes JavaScript communes
        require('./functions/validators.functions');
        // Méthodes jQuery communes
        require('./jquery/adresses.jquery');
        require('./jquery/utilisateurs.jquery');
        /** DEBUT DU CODE JAVASCRIPT EN DESSOUS DE CETTE PARTIE ! */



        /** FIN DU CODE JAVASCRIPT AU DESSUS DE CETTE PARTIE ! */
    }
});
/*
|--------------------------------------------------------------------------
| FIN DU FICHIER - NE RIEN AJOUTER EN DESSOUS !
|--------------------------------------------------------------------------
*/
